// @flow
import { fromJS, Map } from 'immutable';

export const sortOptions = [
  {
    text: 'Newest to Oldest Updated',
    sort: {
      sortBy: 'updated',
      sortDirection: 'DESC'
    }
  },
  {
    text: 'Oldest to Newest Updated',
    sort: {
      sortBy: 'updated',
      sortDirection: 'ASC'
    }
  },
  {
    text: 'Newest to Oldest Created',
    sort: {
      sortBy: 'created',
      sortDirection: 'DESC'
    }
  },
  {
    text: 'Oldest to Newest Created',
    sort: {
      sortBy: 'created',
      sortDirection: 'ASC'
    }
  }
];

export const sortComparators = {
  ASC: (a: any, b: any) => a > b,
  DESC: (a: any, b: any) => a < b
};

export const scoreSortOptions = fromJS([
  {
    key: 'updated',
    displayName: 'Updated A-Z',
    sortByKey: score => score.get('updated')
  },
  {
    key: 'sourceName',
    displayName: 'Source Name',
    sortByKey: (score: Map<string, any>) =>
      score.getIn(['source', 'key'])
  },
  {
    key: 'scoreName',
    displayName: 'Score Name',
    sortByKey: (score: Map<string, Map<any, any>>) =>
      score.getIn(['score', 'name'])
  }
]);

export const getDefaultScoreSortOption = () => scoreSortOptions.get(0);

export const sorterValues = {
  searchSorterPlaceholder: 'Select',
  searchSorters: sortOptions[0]
};



// WEBPACK FOOTER //
// ./src/app/modules/entity-scores/defaults.js